export const defaultProps = {
    currentSlide: 0, //first visible Item (0-based indexing)
    animationTimeInterval: 750,
    transition: "0.75s ease-in-out",
    transitionNone: "0s"
};
